import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const MERCHANT: AppRouteRecordRaw = {
  path: '/merchant',
  name: 'Merchant',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.merchant',
    requiresAuth: true,
    icon: 'icon-user-group',
    order: 5,
    roles: ['superAdmin'],
  },
  children: [
    {
      path: 'management',
      name: 'MerchantManagement',
      component: () => import('@/views/merchant/management/index.vue'),
      meta: {
        locale: 'menu.merchant.management',
        requiresAuth: true,
        roles: ['superAdmin'],
      },
    },
  ],
};

export default MERCHANT;
